import { PARTNER360_NAMESPACE } from 'partner360/configs'

export const PARTNER360_PBM_COCKPIT_NAMESPACE = `${PARTNER360_NAMESPACE}/pbmCockpit`
export const SOB_COLLECTION_PLANNING_TYPE = 'jbp-sob-collecting' as const
